import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import React, { useState, useEffect, useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import viewIcon from '../../assest/images/eye.png';
import backIcon from '../../assest/images/11.jpg';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import ShubhamImage from '../../assest/images/Shubham1.png';
import Icon3 from '../../assest/images/Icon3.png';
import Icon8 from '../../assest/images/Icon8.png';
import { UserContext } from '../common/UserContext';
import config from '../../envconfig';
import { format } from 'date-fns';
import { ToastContainer, toast } from 'react-toastify';
import "react-datepicker/dist/react-datepicker.css";
import { IoCaretUpOutline, IoCaretDownOutline, IoCalendarOutline } from 'react-icons/io5';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import CustomDatepicker from "../common/CustomDatePicker";
import CustomDropdown from '../common/CustomDropdown';

const OrderList = () => {

  const location = useLocation();

  // Access the BYSCP value from state
  const BYSCP = location.state?.BYSCP ?? null; // fallback to null if undefined
  console.log("BYSCPLISR", BYSCP)



  const [orderData1, setOrderData1] = useState([]);
  const [orderData, setOrderData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [ordersPerPage] = useState(10);
  const [selectedOrderDetails, setSelectedOrderDetails] = useState(null);
  const [reload, setReload] = useState(false);
  const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [searchOpt1, setSearchOpt1] = useState('');
  const [searchOpt2, setSearchOpt2] = useState('');
  const [searchTxt1, setSearchTxt1] = useState('');
  const [searchTxt2, setSearchTxt2] = useState('');
  const [selectStatus, setSelectStatus] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [isSelectOpen, setIsSelectOpen] = useState(null);
  const [schemeData, setSchemeData] = useState([]);

  const logAction = async (action, isError = false) => {
    console.log(`${isError ? '[ERROR] ' : ''}${action}`);
    try {
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ module: "Order Master by SCP", action, userCode: UM_UserCode, isError }),
      });
      if (!response.ok) {
        throw new Error('Failed to log action');
      }
    } catch (error) {
      console.error('Error logging action:', error);
    }
  };

  // Assuming BYSCP is already available from useLocation or props
  const isBySalesOfficer = parseInt(BYSCP) === 0;
  const options = [
    ...(isBySalesOfficer
      ? [
        {
          value: 'FromSCPName',
          label: 'From',
          disabled:
            searchOpt1 === 'FromSCPName',
        },
      ]
      : []),

    {
      value: 'ToSCP_Name',
      label: 'To',
      disabled: searchOpt1 === 'ToSCP_Name',
    },
    {
      value: 'ORDM_OrderNumber',
      label: 'Order Number',
      disabled:
        searchOpt1 === 'ORDM_OrderNumber',
    },
    {
      value: 'ORDM_OrderDate',
      label: 'Order Date',
      disabled:
        searchOpt1 === 'ORDM_OrderDate',
    },
  ];

  const options2 = [
    ...(isBySalesOfficer
      ? [
        {
          value: 'FromSCPName',
          label: 'From',
          disabled:
            searchOpt2 === 'FromSCPName',
        },
      ]
      : []),

    {
      value: 'ToSCP_Name',
      label: 'To',
      disabled: searchOpt2 === 'ToSCP_Name',
    },
    {
      value: 'ORDM_OrderNumber',
      label: 'Order Number',
      disabled:
        searchOpt2 === 'ORDM_OrderNumber',
    },
    {
      value: 'ORDM_OrderDate',
      label: 'Order Date',
      disabled:
        searchOpt2 === 'ORDM_OrderDate', // 🔁 fixed typo here
    },
  ];



  const statusOptions = [

    { value: 1, label: 'Created' },
    { value: 2, label: 'Approved' },
    { value: 3, label: 'Rejected' },
    { value: 4, label: 'Shipment' },
    { value: 5, label: 'Goods Receipt' },
    { value: 6, label: 'Completed' },
    { value: 7, label: 'Closed' },
  ];

  const handleSelectOpen = (selectName) => {
    setIsSelectOpen(selectName);
  };

  const handleSelectClose = () => {
    setIsSelectOpen(null);
  };

  const handleOpt1 = (arg) => {
    // arg can be: event, option object, string, etc.
    let newValue = '';

    if (arg?.target) {
      // Case 1: event from CustomDropdown: { target: { value } }
      newValue = arg.target.value;
    } else if (typeof arg === 'string') {
      // Case 2: directly passed string
      newValue = arg;
    } else if (arg && typeof arg === 'object') {
      // Case 3: option object like { value: 'ToSCP_Name', label: 'To' }
      if ('value' in arg) newValue = arg.value;
    }



    if (newValue !== searchOpt1) {
      console.log('Updating searchOpt1 from', searchOpt1, 'to', newValue);
      setSearchOpt1(newValue);
      setSearchTxt1('');
    }

    if (newValue !== 'ORDM_OrderDate' && searchOpt2 !== 'ORDM_OrderDate') {
      console.log('Clearing date filters from handleOpt1');
      setStartDate('');
      setEndDate('');
    }
  };

  const handleOpt2 = (arg) => {
    let newValue = '';

    if (arg?.target) {
      newValue = arg.target.value;
    } else if (typeof arg === 'string') {
      newValue = arg;
    } else if (arg && typeof arg === 'object') {
      if ('value' in arg) newValue = arg.value;
    }


    if (newValue !== searchOpt2) {

      setSearchOpt2(newValue);
      setSearchTxt2('');
    }

    if (newValue !== 'ORDM_OrderDate' && searchOpt1 !== 'ORDM_OrderDate') {

      setStartDate('');
      setEndDate('');
    }
  };



  const handleTxt1 = (e) => {
    setSearchTxt1(e.target.value);
  };

  const handleTxt2 = (e) => {
    setSearchTxt2(e.target.value);
  };

  const handleStatus = (arg) => {
    let newValue = '';

    if (arg?.target) newValue = arg.target.value;
    else if (arg && typeof arg === 'object' && 'value' in arg) newValue = arg.value;
    else if (typeof arg === 'string') newValue = arg;

    console.log('handleStatus -> newValue:', newValue);
    setSelectStatus(newValue);
  };


  // const pdfdownload = async (orderNumber) => {

  //   try {
  //     // 1️⃣ Fetch ORDER DETAILS
  //     const orderRes = await fetch(`${config.API_URL}/OM/pdf/orders/${orderNumber}`);
  //     if (!orderRes.ok) throw new Error("Network response was not ok (order details)");
  //     const orderData = await orderRes.json();
  //     console.log("📦 Order Data:", orderData);
  //     setOrderData1(orderData);

  //     // 2️⃣ Fetch SCHEME DETAILS (if available)
  //     // 2️⃣ Fetch SCHEME DETAILS (if available)
  //     let schemeData = [];
  //     try {
  //       const schemeRes = await fetch(`${config.API_URL}/OM/orderscheme/${orderNumber}`);
  //       if (schemeRes.ok) {
  //         const schemeJson = await schemeRes.json();
  //         console.log("🎯 Scheme Details:", schemeJson);
  //         if (schemeJson.success && Array.isArray(schemeJson.schemes) && schemeJson.schemes.length > 0) {
  //           schemeData = schemeJson.schemes;
  //           setSchemeData(schemeData);
  //         } else {
  //           console.log("ℹ️ No scheme found for this order (empty array).");
  //         }
  //       } else if (schemeRes.status === 404) {
  //         console.log("ℹ️ No scheme found for this order (404).");
  //       } else {
  //         throw new Error("Network error fetching scheme");
  //       }
  //     } catch (error) {
  //       console.error("❌ Error fetching scheme details:", error);
  //     }

  //     // 3️⃣ Setup jsPDF document
  //     const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
  //     const textColor = [0, 0, 0];
  //     const headerTextColor = [255, 255, 255];
  //     const headerColor = [135, 206, 250];
  //     const rowColor = [255, 255, 255];

  //     const styles = {
  //       detailsTable: { fontSize: 12, color: textColor, fillColor: rowColor },
  //       tableHeader: { fontSize: 12, color: headerTextColor, fillColor: headerColor },
  //       tableRow: { fontSize: 10, color: textColor, fillColor: rowColor },
  //     };

  //     // Logo & header info
  //     const imgData = ShubhamImage;
  //     doc.addImage(imgData, "PNG", 10, 10, 40, 20);

  //     const date = new Date();
  //     const formattedDate = `${String(date.getDate()).padStart(2, "0")}/${String(date.getMonth() + 1).padStart(2, "0")
  //       }/${date.getFullYear()} ${String(date.getHours()).padStart(2, "0")
  //       }:${String(date.getMinutes()).padStart(2, "0")
  //       }:${String(date.getSeconds()).padStart(2, "0")}`;

  //     doc.setFontSize(10);


  //     const labelWidth = doc.getTextWidth("Printed On  :"); // longest label
  //     // const printedBy = `Printed By  :  `.padEnd(labelWidth / 2) + UM_UserCode;
  //     // const printedOn = `Printed On  : `.padEnd(labelWidth / 2) + formattedDate;

  //     const startX = doc.internal.pageSize.getWidth() - 50;
  //     const startY = 20;
  //     const baseX = startX;
  //     const y1 = startY + 5;
  //     const y2 = startY;

  //     const colonOffset = 14.5;  // distance from label to colon
  //     const valueOffset = 16.5;  // distance from label to value (a few px after colon)

  //     doc.setFontSize(8);

  //     // 📝 Printed On
  //     doc.text("Printed On", baseX, y2, { align: "left" });
  //     doc.text(":", baseX + colonOffset, y2);
  //     doc.text(formattedDate, baseX + valueOffset, y2);

  //     // 📝 Printed By
  //     doc.text("Printed By", baseX, y1, { align: "left" });
  //     doc.text(":", baseX + colonOffset, y1);
  //     doc.text(UM_UserCode, baseX + valueOffset, y1);

  //     // 4️⃣ ORDER DETAILS TABLE
  //     const detailsTable = [
  //       [
  //         {
  //           content: "Order Information",
  //           colSpan: 2,
  //           styles: { halign: "center", fontSize: 14, fillColor: [41, 128, 185], textColor: [255, 255, 255] },
  //         },
  //       ],
  //       ["Order Number", orderData[0].ORDM_OrderNumber],
  //       ["Order Date & Time", formatDate(orderData[0].ORDM_OrderDate)],
  //       ["Order Type", orderData[0].ORDM_TypeDescription],
  //       ["Order Status", orderData[0].ORDM_OrderStatusDescription],
  //       ["From", orderData[0].ORDM_FromSCPName],
  //       ["To", orderData[0].ORDM_ToSCPName],
  //     ];

  //     doc.autoTable({
  //       head: [],
  //       body: detailsTable,
  //       startY: 40,
  //       theme: "grid",
  //       styles: styles.detailsTable,
  //     });

  //     let currentY = doc.autoTable.previous.finalY + 5;


  //     if (schemeData && schemeData.length > 0) {
  //       const schemeHeader = [
  //         [
  //           {
  //             content: "Scheme Details",
  //             colSpan: 2,
  //             styles: { halign: "center", fontSize: 14, fillColor: [41, 128, 185], textColor: [255, 255, 255] },
  //           },
  //         ],
  //       ];

  //       // Each scheme row as key-value pairs
  //       const schemeBody = schemeData.flatMap((item) => [
  //         ["Scheme Name", item.SchemeName || "N/A"],
  //         ["Scheme Description", item.SchemeDescription || "N/A"],
  //         ["Benefit", item.Benefit || "N/A"],
  //       ]);

  //       doc.autoTable({
  //         head: [],
  //         body: [...schemeHeader, ...schemeBody],
  //         startY: currentY,
  //         theme: "grid",
  //         styles: styles.detailsTable,
  //       });

  //       currentY = doc.autoTable.previous.finalY + 5;
  //     }

  //     const prodRes = await fetch(`${config.API_URL}/OM/pdf/product/${orderNumber}`);
  //     if (!prodRes.ok) throw new Error("Network response was not ok (product details)");
  //     const prodData = await prodRes.json();


  //     // 🧠 Merge free product info from schemeData (SchemeType === 2)
  //     let mergedProducts = [...prodData];

  //     if (schemeData && schemeData.length > 0) {
  //       const freeSchemes = schemeData.filter((s) => s.SchemeType === 2);
  //       freeSchemes.forEach((scheme) => {
  //         (scheme.freeProducts || []).forEach((freeItem) => {
  //           // Normalize possible field names
  //           const freeId =
  //             freeItem.freeProductId || freeItem.PL_ProductId || freeItem.productId;
  //           const freeName =
  //             freeItem.freeProductName || freeItem.PL_ProductName || "Unknown";
  //           const freeCode =
  //             freeItem.freeProductCode || freeItem.PL_ProductCode || "-";
  //           const freeQty =
  //             freeItem.freeQuantity || freeItem.ORDIT_FreeQty || freeItem.ORDIT_OrderQTY;

  //           // Find existing product in order list
  //           const existingIndex = mergedProducts.findIndex(
  //             (p) => String(p.PL_ProductId) === String(freeId)
  //           );

  //           if (existingIndex !== -1) {
  //             // ✅ Product already exists → merge quantities
  //             const existingQty = mergedProducts[existingIndex].ORDIT_OrderQTY;
  //             if (!String(existingQty).includes("(Free)")) {
  //               mergedProducts[existingIndex] = {
  //                 ...mergedProducts[existingIndex],
  //                 ORDIT_OrderQTY: `${existingQty} + ${freeQty} (Free)`,
  //               };
  //             }
  //           } else {
  //             // 🚀 Add new free-only product row
  //             mergedProducts.push({
  //               PL_ProductId: freeId,
  //               PL_ProductName: freeName,
  //               PL_ProductCode: freeCode,
  //               ORDIT_OrderQTY: `${freeQty} (Free)`,
  //               isFree: true,
  //             });
  //           }
  //         });
  //       });
  //     }

  //     // 🔹 Prepare table data with serial numbers
  //     const headers = ["Sr. No.", "Product Name", "Product Code", "Order Quantity"];
  //     const bodyWithSrNo = mergedProducts.map((item, index) => [
  //       index + 1,
  //       item.PL_ProductName,
  //       item.PL_ProductCode,
  //       item.ORDIT_OrderQTY,
  //     ]);

  //     // 🧾 Render table
  //     doc.autoTable({
  //       head: [
  //         [
  //           {
  //             content: "Product Details",
  //             colSpan: headers.length,
  //             styles: { halign: "center", fontSize: 14, fillColor: [41, 128, 185], textColor: [255, 255, 255] },
  //           },
  //         ],
  //         headers,
  //       ],
  //       body: bodyWithSrNo,
  //       startY: currentY,
  //       theme: "grid",
  //       styles: styles.detailsTable,
  //       headStyles: { fillColor: [41, 128, 185], textColor: [255, 255, 255] },
  //     });


  //     // Optional footer function
  //     if (typeof addFooter === "function") addFooter(doc);

  //     // 7️⃣ Save PDF
  //     doc.save(`${orderNumber}.pdf`);

  //   } catch (error) {
  //     console.error("❌ Error generating PDF:", error);
  //   }
  // };

  const loadImageAsBase64 = async (imageUrl, fallbackImage) => {
    try {
      console.log("url", imageUrl)
      const res = await fetch(imageUrl, { cache: "no-store" });
      console.log("res", res)
      if (!res.ok) throw new Error("Image not found");

      const blob = await res.blob();

      return await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.log("⚠️ Logo not found, using default logo");
      return fallbackImage;
    }
  };

  const pdfdownload = async (orderNumber) => {

    try {
      // 1️⃣ Fetch ORDER DETAILS
      const orderRes = await fetch(`${config.API_URL}/OM/pdf/orders/${orderNumber}`);
      if (!orderRes.ok) throw new Error("Network response was not ok (order details)");
      const orderData = await orderRes.json();
      console.log("📦 Order Data:", orderData);
      setOrderData1(orderData);

      // 2️⃣ Fetch SCHEME DETAILS (if available)
      // 2️⃣ Fetch SCHEME DETAILS (if available)
      let schemeData = [];
      try {

        const schemeRes = await fetch(`${config.API_URL}/OM/orderscheme/${orderNumber}`);
        if (schemeRes.ok) {
          const schemeJson = await schemeRes.json();
          console.log("🎯 Scheme Details:", schemeJson);
          if (schemeJson.success && Array.isArray(schemeJson.schemes) && schemeJson.schemes.length > 0) {
            schemeData = schemeJson.schemes;
            setSchemeData(schemeData);
          } else {
            console.log("ℹ️ No scheme found for this order (empty array).");
          }
        } else if (schemeRes.status === 404) {
          console.log("ℹ️ No scheme found for this order (404).");
        } else {
          throw new Error("Network error fetching scheme");
        }
      } catch (error) {
        console.error("❌ Error fetching scheme details:", error);
      }

      // 3️⃣ Setup jsPDF document
      const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
      const textColor = [0, 0, 0];
      const headerTextColor = [255, 255, 255];
      const headerColor = [38, 90, 128];
      const rowColor = [255, 255, 255];
      const MARGIN = 10;

      const styles = {
        detailsTable: {
          fontSize: 10,
          cellPadding: { top: 1, bottom: 1 }, textColor: textColor, fillColor: rowColor, lineColor: [0, 0, 0],
          lineWidth: 0.5, cellPadding: 1,
        },
        tableHeader: {
          fontSize: 10, textColor: headerTextColor, fillColor: headerColor, fontStyle: "bold",
          cellPadding: 1,
        },
        tableRow: {
          fontSize: 10, textColor: textColor, fillColor: rowColor, lineColor: [0, 0, 0],
          lineWidth: 0.5, cellPadding: 1, halign: "center"
        },
      };

      // 4️⃣ Load logo dynamically
      const logoPath = `${config.REACT_APP_REPORT_LOGO_PATH}${UM_CompanyGrpID}/logo.png`;
      //const imgData = await loadImageAsBase64(logoPath, ShubhamImage);

      const logoRes = await fetch(`${config.API_URL}/logo-base64/${UM_CompanyGrpID}`);
      const logoJson = await logoRes.json();
      const imgData = logoJson.base64 || ShubhamImage;


      // Logo & header info
      //const imgData = ShubhamImage;
      doc.addImage(imgData, "PNG", 10, 10, 40, 20);

      const date = new Date();
      const formattedDate = `${String(date.getDate()).padStart(2, "0")}/${String(date.getMonth() + 1).padStart(2, "0")
        }/${date.getFullYear()} ${String(date.getHours()).padStart(2, "0")
        }:${String(date.getMinutes()).padStart(2, "0")
        }:${String(date.getSeconds()).padStart(2, "0")}`;

      doc.setFontSize(10);


      const labelWidth = doc.getTextWidth("Printed On  :"); // longest label
      // const printedBy = `Printed By  :  `.padEnd(labelWidth / 2) + UM_UserCode;
      // const printedOn = `Printed On  : `.padEnd(labelWidth / 2) + formattedDate;

      const startX = doc.internal.pageSize.getWidth() - 50;
      const startY = 20;
      const baseX = startX;
      const y1 = startY + 5;
      const y2 = startY;

      const colonOffset = 14.5;  // distance from label to colon
      const valueOffset = 16.5;  // distance from label to value (a few px after colon)

      doc.setFontSize(8);

      // 📝 Printed On
      doc.text("Printed On", baseX, y2, { align: "left" });
      doc.text(":", baseX + colonOffset, y2);
      doc.text(formattedDate, baseX + valueOffset, y2);

      // // 📝 Printed By
      // doc.text("Printed By", baseX, y1, { align: "left" });
      // doc.text(":", baseX + colonOffset, y1);
      // doc.text(UM_UserCode, baseX + valueOffset, y1);

      // 4️⃣ ORDER DETAILS TABLE
      const detailsTable = [
        [
          {
            content: "Order Information",
            colSpan: 2,
            styles: {
              halign: "center", fontSize: 10, fillColor: [38, 90, 128], textColor: [255, 255, 255], fontStyle: "bold",
              cellPadding: { top: 1, bottom: 1 }, lineColor: [0, 0, 0],
              lineWidth: 0.5,
            },
          },
        ],
        ["Order Number", orderData[0].ORDM_OrderNumber],
        ["Order Date & Time", formatDate(orderData[0].ORDM_OrderDate)],
        ["Order Type", orderData[0].ORDM_TypeDescription],
        ["Order Status", orderData[0].ORDM_OrderStatusDescription],
        ["From", orderData[0].ORDM_FromSCPName],
        ["To", orderData[0].ORDM_ToSCPName],
      ];

      doc.autoTable({
        head: [],
        margin: { left: MARGIN, right: MARGIN },
        body: detailsTable,
        startY: 40,
        theme: "grid",
        styles: styles.detailsTable,
      });

      let currentY = doc.autoTable.previous.finalY + 5;


      if (schemeData && schemeData.length > 0) {
        const schemeDetailsTable = [
          [
            {
              content: "Scheme Details",
              colSpan: 2, // ✅ SAME AS ORDER INFORMATION
              styles: {
                halign: "center",
                fontSize: 10,
                fillColor: [38, 90, 128],
                textColor: [255, 255, 255],
                fontStyle: "bold",
                cellPadding: { top: 1, bottom: 1 },
                lineColor: [0, 0, 0],
                lineWidth: 0.5,
              },
            },
          ],
        ];

        // BODY
        schemeData.forEach((item) => {
          schemeDetailsTable.push(
            ["Scheme Name", item.SchemeName || "N/A"],
            ["Scheme Description", item.SchemeDescription || "N/A"],
            ["Benefit", item.Benefit || "N/A"]
          );
        });

        doc.autoTable({
          head: [],
          margin: { left: MARGIN, right: MARGIN },
          body: schemeDetailsTable,
          startY: currentY,
          theme: "grid",
          styles: styles.detailsTable,
        });

        currentY = doc.autoTable.previous.finalY + 1;

      }

      const prodRes = await fetch(`${config.API_URL}/OM/pdf/product/${orderNumber}`);
      if (!prodRes.ok) throw new Error("Network response was not ok (product details)");
      const prodData = await prodRes.json();


      // 🧠 Merge free product info from schemeData (SchemeType === 2)
      let mergedProducts = [...prodData];

      if (schemeData && schemeData.length > 0) {
        const freeSchemes = schemeData.filter((s) => s.SchemeType === 2);
        freeSchemes.forEach((scheme) => {
          (scheme.freeProducts || []).forEach((freeItem) => {
            // Normalize possible field names
            const freeId =
              freeItem.freeProductId || freeItem.PL_ProductId || freeItem.productId;
            const freeName =
              freeItem.freeProductName || freeItem.PL_ProductName || "Unknown";
            const freeCode =
              freeItem.freeProductCode || freeItem.PL_ProductCode || "-";
            const freeQty =
              freeItem.freeQuantity || freeItem.ORDIT_FreeQty || freeItem.ORDIT_OrderQTY;

            // Find existing product in order list
            const existingIndex = mergedProducts.findIndex(
              (p) => String(p.PL_ProductId) === String(freeId)
            );

            if (existingIndex !== -1) {
              // ✅ Product already exists → merge quantities
              const existingQty = mergedProducts[existingIndex].ORDIT_OrderQTY;
              if (!String(existingQty).includes("(Free)")) {
                mergedProducts[existingIndex] = {
                  ...mergedProducts[existingIndex],
                  ORDIT_OrderQTY: `${existingQty} + ${freeQty} (Free)`,
                };
              }
            } else {
              // 🚀 Add new free-only product row
              mergedProducts.push({
                PL_ProductId: freeId,
                PL_ProductName: freeName,
                PL_ProductCode: freeCode,
                ORDIT_OrderQTY: `${freeQty} (Free)`,
                isFree: true,
              });
            }
          });
        });
      }

      // 🔹 Prepare table data with serial numbers
      const headers = ["Sr. No.", "Product Name", "Product Code", "Order Quantity"];
      const bodyWithSrNo = mergedProducts.map((item, index) => [
        index + 1,
        item.PL_ProductName,
        item.PL_ProductCode,
        item.ORDIT_OrderQTY,
      ]);

      // 🧾 Render table
      doc.autoTable({
        head: [
          [
            {
              content: "Product Details",
              colSpan: headers.length,
              styles: {
                halign: "center", fontSize: 10, fillColor: [38, 90, 128], textColor: [255, 255, 255], fontStyle: "bold",
                cellPadding: { top: 1, bottom: 1 },
              },
            },
          ],
          headers,
        ],
        margin: { left: MARGIN, right: MARGIN },
        body: bodyWithSrNo,
        startY: currentY + 5,
        theme: "grid",
        styles: styles.tableRow,
        headStyles: {
          halign: "center", fontSize: 10, fillColor: [38, 90, 128], textColor: [255, 255, 255], fontStyle: "bold",
          cellPadding: { top: 1, bottom: 1 },
        },
      });

      // ================= SIGNATURE BLOCK =================
      doc.setFontSize(8);
      doc.setTextColor(0, 0, 0);
      doc.setFont(undefined, "normal");

      const leftMargin = 10;
      const rightMargin = 10;

      const startXval = leftMargin;
      const usableWidth = doc.internal.pageSize.getWidth() - leftMargin - rightMargin;

      // Column setup
      const col1 = 35;          // Printed / Checked / Verified label
      const colGap = 6;         // 🔥 Horizontal gap between columns

      const remainingWidth = usableWidth - col1 - (colGap * 2);
      const col2 = remainingWidth / 3; // Name
      const col3 = col2;               // Signature
      const col4 = col2;               // Date

      // Column X positions
      const col1X = startXval;
      const col2X = col1X + col1;
      const col3X = col2X + col2 + colGap;
      const col4X = col3X + col3 + colGap;

      // Start Y position
      let y = doc.autoTable.previous.finalY + 20;

      // Vertical spacing
      const rowGap = 6;

      // ---------- HEADER ----------
      doc.text("Name", col2X + col2 / 2, y, { align: "center" });
      doc.text("Signature", col3X + col3 / 2, y, { align: "center" });
      doc.text("Date", col4X + col4 / 2, y, { align: "center" });

      y += rowGap;

      // ---------- ROW FUNCTION ----------
      const colonX = col1X + 20; // fixed vertical line for colon

      const drawRow = (label) => {
        // draw label WITHOUT colon
        doc.text(label, col1X, y);

        // draw colon at fixed position
        doc.text(":", colonX, y);

        // lines
        doc.line(col2X, y, col2X + col2, y);
        doc.line(col3X, y, col3X + col3, y);
        doc.line(col4X, y, col4X + col4, y);

        y += rowGap;
      };

      // ---------- ROWS ----------
      drawRow("Printed By");
      drawRow("Checked By");
      drawRow("Verified By");


      // Optional footer function
      if (typeof addFooter === "function") addFooter(doc);

      // 7️⃣ Save PDF
      doc.save(`${orderNumber}.pdf`);

    } catch (error) {
      console.error("❌ Error generating PDF:", error);
    }
  };

  const handleDownloadPdf = async (orderNumber, ORDM_OrderID) => {
    try {
        const response = await fetch(`${config.API_URL}/email/order-pdf`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              ORDM_OrderID,
              orderNumber,
              ORDM_CompanyID: UM_CompanyID,
            }),
        });

        // ❌ handle 404 / 500 properly
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        // ✅ get PDF blob
        const blob = await response.blob();

        // ✅ download
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${orderNumber}.pdf`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        //toast.success('PDF downloaded successfully');


    } catch (error) {
        console.error('PDF download error:', error);
        toast.error('Failed to download PDF');
    }
};

  const addFooter = (doc) => {
    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);
      doc.text(
        "Developed by : Shubham Automation Pvt. Ltd.",
        10,
        doc.internal.pageSize.getHeight() - 10
      );
      doc.text(
        `Page ${i} of ${totalPages}`,
        doc.internal.pageSize.getWidth() - 20,
        doc.internal.pageSize.getHeight() - 10,
        { align: "right" }
      );
    }
  };

  useEffect(() => {
    fetchOrderData();
  }, []);

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return new Date(dateString).toLocaleDateString('en-GB', options);
  };

  const fetchOrderData = async () => {
    try {
      setLoading(true);

      // 👇 Choose API endpoint based on BYSCP value
      const url =
        parseInt(BYSCP) === 0
          ? `${config.API_URL}/OM/ProductViewSO/${UM_UserId}` // 👈 Sales Officer (BYSCP = 0)
          : `${config.API_URL}/OM/ProductView/${selectedScpId}`; // 👈 SCP (BYSCP ≠ 0)

      console.log("📡 Fetching from:", url);

      const response = await fetch(url);

      if (response.ok) {
        const data = await response.json();
        console.log("✅ Order Data:", data);

        const orderMap = new Map();

        data.forEach((order) => {
          const orderNumber = order.ORDM_OrderNumber;
          const createdTimestamp = new Date(order.ORDIT_CreatedTimestamp);

          if (orderMap.has(orderNumber)) {
            const existingCreatedTimestamp = new Date(
              orderMap.get(orderNumber).ORDIT_CreatedTimestamp
            );
            if (createdTimestamp > existingCreatedTimestamp) {
              orderMap.set(orderNumber, order);
            }
          } else {
            orderMap.set(orderNumber, order);
          }
        });

        const uniqueOrders = Array.from(orderMap.values());
        // uniqueOrders.sort(
        //   (a, b) =>
        //     new Date(b.ORDIT_CreatedTimestamp) -
        //     new Date(a.ORDIT_CreatedTimestamp)
        // );
        uniqueOrders.sort((a, b) => b.ORDM_OrderID - a.ORDM_OrderID);



        setOrderData(uniqueOrders);
      } else {
        console.error("❌ Failed to fetch order data");
      }
    } catch (error) {
      console.error("❌ Error fetching order data:", error);
    } finally {
      setLoading(false);
    }
  };


  const filterOrderData = () => {
    let filteredData = orderData;

    filteredData = filteredData.filter(item => {
      const fieldMatch1 = !searchTxt1 || !searchOpt1 || String(item[searchOpt1]).toLowerCase().includes(searchTxt1.toLowerCase());
      const fieldMatch2 = !searchTxt2 || !searchOpt2 || String(item[searchOpt2]).toLowerCase().includes(searchTxt2.toLowerCase());

      let dateMatch = true;
      if (startDate && endDate) {
        const itemDate = new Date(item.ORDM_OrderDate);
        const start = new Date(startDate);
        const end = new Date(endDate);
        itemDate.setHours(0, 0, 0, 0);
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);
        dateMatch = itemDate >= start && itemDate <= end;
      }

      const statusMatch = !selectStatus || item.ORDM_OrderStatus === selectStatus;

      return fieldMatch1 && fieldMatch2 && dateMatch && statusMatch;
    });

    return filteredData;
  };


  const totalPages = Math.ceil(filterOrderData().length / ordersPerPage);
  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = filterOrderData().slice(indexOfFirstOrder, indexOfLastOrder);

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const renderStatus = (status) => {
    switch (status) {
      case 1:
        return <span>Created</span>;
      case 2:
        return <span>Approved</span>;
      case 3:
        return <span>Rejected</span>;
      case 4:
        return <span>Shipment</span>;
      case 5:
        return <span>Goods Receipt</span>;
      case 6:
        return <span>Completed</span>;
      case 7:
        return <span>Closed</span>;
      default:
        return <span>Unknown Status</span>;
    }
  };

  useEffect(() => {
    const totalPages = Math.ceil(filterOrderData().length / ordersPerPage);
    if (currentPage > totalPages && totalPages > 0) {
      setCurrentPage(totalPages);
    } else if (totalPages === 0 && currentPage !== 1) {
      setCurrentPage(1);
    }
  }, [searchTxt1, searchTxt2, selectStatus, startDate, endDate, orderData, currentPage, ordersPerPage]);

  const targetPath = '/dashboard/ordermaster';

  return (
    <React.Fragment>
      <ToastContainer style={{
        marginTop: '73px',
        fontSize: '14px',
        width: '40%',
      }} />
      <div className='main_container' style={{ msOverflowStyle: 'none', scrollbarWidth: 'none', overflow: 'auto', maxHeight: '550px' }}>
        <div className='row'>
          <div className='col-md-12'>
            <div>
              <h4 className="formHeading">
                {parseInt(BYSCP) === 0
                  ? "Order Master (by Sales Officer)"
                  : "Order Master (by SCP)"}
              </h4>
            </div>
            <div className='filter-container'>
              <div className='select-container_list'>
                <CustomDropdown
                  name="searchOpt1"
                  options={options2}
                  value={searchOpt1}                          // store only value
                  onChange={handleOpt1}
                  placeholder="--Select--"
                  idKey="value"                               // key used in options
                  displayKey="label"                          // key used to show text
                  disabled={false}
                  onMenuOpen={() => handleSelectOpen("searchOpt1")}
                  onMenuClose={handleSelectClose}
                  style={{ fontSize: '5px' }}
                />


              </div>
              <input type='text' value={searchTxt1} onChange={handleTxt1} className='search-input searchbar' placeholder="Search"></input>
              <div className='select-container_list'>
                <CustomDropdown
                  name="searchOpt2"
                  options={options}
                  value={searchOpt2}                           // only selected value
                  onChange={handleOpt2}
                  placeholder="--Select--"
                  idKey="value"                                // must match your option keys
                  displayKey="label"                           // must match your option keys
                  disabled={false}
                  onMenuOpen={() => handleSelectOpen("searchOpt2")}
                  onMenuClose={handleSelectClose}
                />


              </div>
              <input type='text' value={searchTxt2} onChange={handleTxt2} className='search-input searchbar' placeholder="Search"></input>
              <div className='select-container_list'>
                <CustomDropdown
                  name="statusFilter"
                  options={statusOptions}
                  value={selectStatus}
                  onChange={handleStatus}
                  placeholder="--Select Status--"
                  idKey="value"
                  displayKey="label"
                  disabled={false}
                  onMenuOpen={() => handleSelectOpen("statusFilter")}
                  onMenuClose={handleSelectClose}
                />
              </div>
            </div>
            {(searchOpt1 === 'ORDM_OrderDate' || searchOpt2 === 'ORDM_OrderDate') && (
              <div className="filter-container">
                <div className="from-container" style={{ flex: 1 }}>
                  <label>From</label>
                  <div className="select-container_list">
                    <DatePicker
                      selected={startDate}
                      onChange={(date) => {
                        setStartDate(date);
                        if (!date) {
                          setEndDate(null);
                        }
                        if (!endDate && date) {
                          setEndDate(date);
                        }
                      }}
                      dateFormat="dd/MM/yyyy"
                      showPopperArrow={false}
                      popperPlacement="bottom"
                      className="routing_select-box"
                      placeholderText="--Select--"
                      maxDate={new Date()}
                      onKeyDown={(e) => e.preventDefault()}
                      customInput={<CustomDatepicker />}
                    />
                    <div className='icon-container_list myList'>
                      <i><IoCalendarOutline /></i>
                    </div>
                  </div>
                </div>
                <div className="to-container" style={{ flex: 1 }}>
                  <label>To</label>
                  <div className="select-container_list">
                    <DatePicker
                      selected={endDate}
                      onChange={(date) => setEndDate(date)}
                      dateFormat="dd/MM/yyyy"
                      showPopperArrow={false}
                      popperPlacement="bottom"
                      onKeyDown={(e) => e.preventDefault()}
                      className="routing_select-box"
                      placeholderText="--Select--"
                      minDate={startDate}
                      disabled={!startDate}
                      maxDate={new Date()}
                      customInput={<CustomDatepicker />}
                    />
                    <div className='icon-container_list myList'>
                      <i><IoCalendarOutline /></i>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <table className="tableClass" key={reload ? 'reload-1' : 'reload-2'}>
              <thead>
                <tr>
                  <th style={{width:'65px'}}>Sr. No.</th>
                  {parseInt(BYSCP) === 0 && <th>From</th>}

                  <th>To</th>
                  <th>Order Number</th>
                  <th>Order Date</th>
                  <th >Order Status</th>
                  <th >Action</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td><h3>Loading...</h3></td></tr>
                ) : (
                  <>
                    {(currentOrders.length === 0) && (
                      <tr>
                        <td colSpan="4">No Records Found</td>
                      </tr>
                    )}
                    {currentOrders.map((order, index) => (
                      <tr key={index}>
                        <td style={{width:'65px'}}  >{indexOfFirstOrder + index + 1}</td>
                        {parseInt(BYSCP) === 0 && <td>{order.FromSCPName}</td>}
                        <td>{order.ToSCP_Name}</td>
                        <td>{order.ORDM_OrderNumber}</td>
                        <td>{formatDate(order.ORDM_OrderDate)}</td>
                        <td >{renderStatus(order.ORDM_OrderStatus)}</td>
                        <td >

                          {order.ORDM_OrderStatus === 1 || order.ORDM_OrderStatus === 2 ? (
                            <Link to={`/dashboard/editorder/${order.ORDM_OrderNumber}`} onClick={() => logAction(`Redirecting to Edit - ${order.ORDM_OrderNumber}`)} state={{ BYSCP }} >
                              <img title='Edit' src={Icon3} alt="Edit" className="editicon" />
                            </Link>
                          ) : (
                            <span>&ensp;&ensp;&ensp;</span>
                          )}
                          <Link
                            to={`/dashboard/OrdView/${order.ORDM_OrderNumber}`}
                            state={{ BYSCP }} // 👈 Pass state here
                          >
                            <img
                              title="View"
                              src={viewIcon}
                              alt="View"
                              style={{ width: "20px", height: "20px", cursor: "pointer" }}
                            />
                          </Link>
                          <img title='Print' className='printicon' src={Icon8} onClick={() => handleDownloadPdf(order.ORDM_OrderNumber, order.ORDM_OrderID)}></img>
                        </td>
                      </tr>
                    ))}
                  </>
                )}
              </tbody>
            </table>

          </div>
        </div>
        <ul className="pagination mt-3">
          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
            <button className="page-linkd" onClick={() => paginate(1)}>First</button>
          </li>
          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
            <button className="page-linkd" onClick={() => paginate(currentPage - 1)}>Previous</button>
          </li>
          {(() => {
            const maxPageButtons = 5;
            let startPage = Math.max(currentPage - Math.floor(maxPageButtons / 2), 1);
            let endPage = startPage + maxPageButtons - 1;

            if (endPage > totalPages) {
              endPage = totalPages;
              startPage = Math.max(endPage - maxPageButtons + 1, 1);
            }

            const pageButtons = [];
            for (let i = startPage; i <= endPage; i++) {
              pageButtons.push(
                <li key={i} className={`page-item ${currentPage === i ? "active" : ""}`}>
                  <button className="page-linkd" onClick={() => paginate(i)}>{i}</button>
                </li>
              );
            }

            return pageButtons;
          })()}
          <li className={`page-item ${currentPage === totalPages || currentOrders.length === 0 ? "disabled" : ""}`}>
            <button className="page-linkd" onClick={() => paginate(currentPage + 1)}>Next</button>
          </li>
          <li className={`page-item ${currentPage === totalPages ||  currentOrders.length === 0 ? "disabled" : ""}`}>
            <button className="page-linkd" onClick={() => paginate(totalPages)}>Last</button>
          </li>
        </ul>
      </div>
      <Link
        to={targetPath}
        state={{ BYSCP }}
        onClick={() =>
          logAction(
            `Redirecting (${parseInt(BYSCP) === 0 ? "ORDER MASTER BY SALES OFFICER" : "ORDER MASTER BY SCP"})`
          )
        }
        className="back_btn"
      >
        BACK
      </Link>
    </React.Fragment>
  );
};

export default OrderList;